var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48 12C40.8799 12 33.9197 14.1114 27.9995 18.0671C22.0793 22.0228 17.4651 27.6453 14.7404 34.2234C12.0156 40.8015 11.3027 48.0399 12.6917 55.0232C14.0808 62.0066 17.5095 68.4211 22.5442 73.4558C27.5789 78.4905 33.9934 81.9192 40.9768 83.3083C47.9601 84.6973 55.1985 83.9844 61.7766 81.2596C68.3547 78.5349 73.9772 73.9207 77.9329 68.0005C81.8886 62.0803 84 55.1201 84 48C84 38.4522 80.2072 29.2955 73.4558 22.5442C66.7045 15.7928 57.5478 12 48 12ZM45.5173 58.5517C44.9949 58.9924 44.3383 59.2425 43.6552 59.2611C43.3053 59.2723 42.9573 59.2066 42.6356 59.0687C42.3139 58.9308 42.0263 58.7241 41.7931 58.463L30.4434 46.8473L34.2562 43.1231L43.7439 52.8768L62.3645 35.3202L66 39.2217L45.5173 58.5517Z",
    fill: "#268035"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDone);
export default __webpack_public_path__ + "static/media/Done.af2296a1c859d366e4eae5777418d158.svg";
export { ForwardRef as ReactComponent };